import { render, staticRenderFns } from "./parameter.vue?vue&type=template&id=3906d001&scoped=true&"
import script from "./parameter.vue?vue&type=script&lang=js&"
export * from "./parameter.vue?vue&type=script&lang=js&"
import style0 from "./parameter.vue?vue&type=style&index=0&id=3906d001&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3906d001",
  null
  
)

export default component.exports